















































import Component, {mixins} from "vue-class-component";
import {fields} from "./config";
import LastTransactions from "./components/LastTransactions.vue";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import BlockBase from "@/components/BlockBase.vue";
import BaseFlexForm from "@/components/BaseFlexForm.vue";
import {$t} from "@/lib/helpers/i18nHelper";
import {toFloat} from "@/lib/helpers/numberHelpers";
import WithTransactions from "@/mixins/WithTransactions";
import {Dictionary, FormFields, FormValues} from "@/types";
import {CheckAuthorities} from "@/lib/helpers/componentViewController/decorators";
import WithLoggedInUser from "@/mixins/WithLoggedInUser";
import FormatMoney from "@/components/FormatMoney";
import {
  InputTransactionManual,
  InputTransactionsSearch,
  Transaction,
} from "@teacherskaya/api-provider/dist/api/TransactionProvider";
import {Prop} from "vue-property-decorator";
import {User} from "@teacherskaya/api-provider/dist/api/UserProvider";

@Component({
  name: "BlockTransactions",
  components: {
    LastTransactions,
    WrapperCheckAuthorities,
    BlockBase,
    FormatMoney,
    BaseFlexForm,
  },
})
export default class BlockTransactions extends mixins(WithTransactions, WithLoggedInUser) {
  @Prop({ required: true, type: Object })
  public readonly user!: User;

  public valid: boolean = true;

  public fields: FormFields = [...fields];

  public fieldsErrors: Dictionary<string[]> = {};

  public values: FormValues = {};

  public balance: string = Number(0).toFixed(2);

  public payoutTransactions: Transaction[] = [];

  @CheckAuthorities("Transactions", ctx => ctx.ruleKey)
  public allowViewTransactions!: boolean;

  get userId() {
    return this.user.id;
  }

  get ruleKey() {
    return this.userId === this.loggedInUser.id ? "get_my" : "get_any";
  }

  get transactions() {
    return (this.transactionsState && this.transactionsState.result) || [];
  }

  public setValid(isValid: boolean) {
    this.valid = isValid;
  }

  public setValues(values: FormValues) {
    this.values = values;
    this.fieldsErrors = {};
  }

  public save() {
    if (!this.valid) return;
    const data: InputTransactionManual = {
      amount: Number(this.values.amount),
      description: this.values.description || "",
      userId: this.userId,
    };
    if (isNaN(data.amount) || data.amount === 0) {
      this.$set(this.fieldsErrors, "amount", [$t("Amount is required")]);
      return;
    }
    if (data.description.length === 0) {
      this.$set(this.fieldsErrors, "description", [$t("Descriptions is required")]);
      return;
    }
    this.transactionsCreate({ data }).then(() => {
      this.values = {};
      this.getActualData();
    });
  }

  public getActualData() {
    this.transactionsGetBalance({ userIds: [this.userId] }).then(response => {
      this.balance = toFloat(response[this.userId]);
    });
    const data: InputTransactionsSearch = {
      size: 5,
      sort: "TIME,DESC",
      userId: this.userId,
    };
    const payoutData: InputTransactionsSearch = {
      size: 1,
      sort: "TIME,DESC",
      type: "PAYOUT",
      userId: this.userId,
    };
    if (this.allowViewTransactions) {
      this.transactionsSearch({ data }).then(state => {
        this.transactionsState = state;
      });
      this.transactionsSearch({ data: payoutData }).then(state => {
        this.payoutTransactions = state.result;
      });
    }
  }

  public created() {
    this.getActualData();
  }
}
